/* Component Dependencies */
var PubSub = require('libs/pub-sub');
var searchForm = require('../../libs/searchFormHorizontal-lib');
var modifyResTemplate = require('templates/searchFormHorizontalV2-modifyRes.hbs');
var rateListMenuTemplate = require('templates/searchFormHorizontalV2-rateListMenu.hbs');
var associateSearchTemplate = require('templates/searchFormHorizontalV2-associateSearch.hbs');
var hwsPageTemplate = require('templates/searchFormHorizontalV2-hws.hbs');
var tiersPageTemplate = require('templates/searchFormHorizontalV2-tiers.hbs');
var roomDetailsTemplate = require('templates/searchFormHorizontalV2-hwsRoomDetails.hbs');
var bookingCartChangeSellOptionsTemplate = require('templates/searchFormHorizontalV2-bookingCartChangeSellOptions.hbs');
var forceSellFormTemplate = require('templates/searchFormHorizontalV2-forceSellForm.hbs');
var modifyRateListMenuTemplate = require('templates/searchFormHorizontalV2-modifyRateListMenu.hbs');
var modifyReviewResTemplate = require('templates/searchFormHorizontalV2-modifyReviewRes.hbs');
var forceSellFormTemplateV2 = require('templates/searchFormHorizontalV2-forceSellFormV2.hbs');
var associateV2Template = require('templates/searchFormHorizontalV2-associateV2.hbs');
var forceSellFormERSTemplate = require('templates/searchFormHorizontalV2-forceSellFormERS.hbs');
var searchFormVerticalDealsTemplate = require('templates/searchFormVerticalV2-deals.hbs');
var offersNextGenSinglePropTemplate = require('templates/searchFormHorizontalV2-offersNextGenSingleProp.hbs');
//var OfferNextGenHubTemplate = require('templates/searchFormHorizontalV2-offerNextGenHub.hbs');
//var offerNextGenEditSearchTemplate = require('templates/searchFormHorizontalV2-offerNextGenEditSearch.hbs');

PubSub.register(searchForm.extend({
  type: 'searchFormHorizontalV2',
  template: {
    'searchFormHorizontalV2-modifyRes': modifyResTemplate,
    'searchFormHorizontalV2-rateListMenu': rateListMenuTemplate,
    'searchFormHorizontalV2-associateSearch':associateSearchTemplate,
    'searchFormHorizontalV2-hws': hwsPageTemplate,
    'searchFormHorizontalV2-tiers': tiersPageTemplate,
    'searchFormHorizontalV2-roomDetails': roomDetailsTemplate,
    'searchFormHorizontalV2-bookingCartChangeSellOptions': bookingCartChangeSellOptionsTemplate,
    'searchFormHorizontalV2-forceSellForm': forceSellFormTemplate,
    'searchFormHorizontalV2-modifyRateListMenu': modifyRateListMenuTemplate,
    'searchFormHorizontalV2-modifyReviewRes': modifyReviewResTemplate,
    'searchFormHorizontalV2-forceSellFormV2': forceSellFormTemplateV2,
    'searchFormHorizontalV2-associateV2': associateV2Template,
    'searchFormHorizontalV2-forceSellFormERS' : forceSellFormERSTemplate,
    'searchFormVerticalV2-deals' : searchFormVerticalDealsTemplate,
    'searchFormHorizontalV2-offersNextGenSingleProp' : offersNextGenSinglePropTemplate,
   // 'searchFormHorizontalV2-offerNextGenHubTemplate' : OfferNextGenHubTemplate,
    //'searchFormHorizontalV2-offerNextGenEditSearch' : offerNextGenEditSearchTemplate
  }
}));
